@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.default-option {
  display: flex;
  align-items: center;
}

.other-input {
  display: flex;
  flex-direction: row;
  margin: 10px;
  height: 32px;
  > div {
    margin-right: 10px;
  }
}

.cod-payment-type {
  display: flex;
  align-items: center;

  > label {
    padding-right: 10px;
  }
}

.cod-payment-type-dropdown {
  max-width: 100px;
}

.cod-payment-amount {
  display: flex;
  align-items: center;
  flex: 1;

  > label {
    padding-right: 15px;
  }

  > div {
    flex: 1;
    height: 100%;
  }

  input {
    flex: 1;
  }
}

.cod-money-input {
  flex: 1;
}

.multiple-rows {
  display: flex;
  flex-direction: column;
  > div {
    margin-right: 25px;
    margin-top: 5px;
  }
}

.dangerous-goods-dhl label,
.ancillary-endorsement label {
  min-width: 90px;
  text-align: right;
  padding-right: 15px;
  font-size: 14px;
}

.dangerous-goods-selector,
.ancillary-endorsement-selector {
  padding: 8px 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.flex-row {
  display: flex;
  align-items: center;
  padding-left: 5px;

  > label {
    min-width: 90px;
    text-align: right;
    padding-right: 15px;
  }

  > div {
    flex: 1;
    margin-left: 0;
    margin-right: 0;
  }

  button {
    padding-left: 5px;
  }

  button:hover {
    background-color: @new-order--shipping-options--background-color;
    box-shadow: none;
    border: 1px solid @new-order--shipping-options--border-color;
  }
}

.single-input {
  width: 100%;
  margin: 10px 10px 10px 0;

  padding-right: 25px;
}

.bill-to-account {
  display: flex;
  flex-direction: column;
}

.bill-to-row {
  display: flex;
  flex-direction: row;
  align-items: center;

  &:not(:first-child) {
    margin-top: 10px;
  }

  > div {
    flex: 3;
  }

  label {
    flex: 1;
    padding-right: 15px;
    white-space: nowrap;
    text-align: right;
    min-width: 130px;
  }
}

div[class^='modal-body'] .bill-to-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bill-to-account-wrapper {
  display: flex;
  flex: 1;
  flex-direction: column;
  max-width: 100%;

  label {
    font-size: 14px;
  }
}

.bill-to-account-type-dropdown {
  justify-content: flex-end;
  > div {
    &:first-child {
      white-space: normal;
      padding: 7.5px 0;
    }
  }
}

.bigly-dropdown {
  width: 100%;
  background-color: @new-order--shipping-options--background-color;
  border: 1px solid @new-order--shipping-options--border-color;
  border-radius: 4px;
}

.checkbox-with-icon {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.information-icon {
  height: 18px;
  width: 18px;
  margin-left: 7px;
  color: var(--grey-600);

  svg {
    width: 100%;
    height: 100%;
  }
}

.checkbox {
  height: 100%;
}

.package-container {
  color: @new-order--shipping-options--text-color;
}

.sms-notification-radio-list {
  padding-left: 22px;
}

@media screen and (max-width: 1199px) {
  .bill-to-account {
    padding-left: 0;
  }
}

.single-bill-to-text {
  font-weight: @semi-bold;
  padding: 10px;
}

.notification-option-sublabel {
  color: @new-order--shipping-options-sublabel--text-color;
  font-size: 12px;
  margin-left: 22px;
  margin-top: 4px;
}
